import gql from 'graphql-tag'

export const GET_INPI_PROCESSES = gql`
  query inpiProcesses {
    inpiProcesses {
      data {
        _id
        processNumber
        processType
        status
        statusDetail
        trademarkName
        classNumbers
        applicant
        depositDate
        publicationDate
        grantDate
        lastScrapedAt
        lastMovement {
          date
          description
        }
      }
    }
  }
`

export const GET_INPI_NOTIFICATION_RECIPIENTS = gql`
  query inpiNotificationRecipients {
    inpiNotificationRecipients {
      accountUserIds
    }
  }
`

export const GET_INPI_PROCESS = gql`
  query inpiProcess($id: String!) {
    inpiProcess(id: $id) {
      _id
      processNumber
      processType
      status
      statusDetail
      trademarkName
      classNumbers
      applicant
      depositDate
      publicationDate
      grantDate
      vigenciaDate
      apresentacao
      natureza
      procurador
      autor
      linguagem
      campoAplicacao
      tipoPrograma
      renewalPeriods {
        ordinary { start end }
        extraordinary { start end }
      }
      classes { classeNice situacao especificacao }
      petitions { protocolo data servico servicoDescricao cliente status statusDescricao }
      lastUpdateInfo
      lastScrapedAt
      movements {
        _id
        date
        description
        code
        rpi
        complemento
      }
    }
  }
`
